<template>
  <div class="step3">
    <a-result status="success" title="申请成功" sub-title="请及时支付款项">
      <template #extra>
        <a-button @click="back"> 返回 </a-button>
      </template>
    </a-result>
    <input id="input" style="opacity: 0; position: absolute" />
    <div class="desc-wrap" v-if="ct.projects && ct.projects.status == 2 && ct.poundage > 0">
      <a-descriptions
        :column="1"
        :labelStyle="{
          width: '200px',
          textAlign: 'right',
        }"
        title="付款信息"
      >
        <a-descriptionsItem label="项目名称">
          {{ ct.project }}
        </a-descriptionsItem>
        <a-descriptionsItem label="付款时间">
          <div class="text-red-500">请在 {{ ct.kbdate }} 前支付</div>
        </a-descriptionsItem>
        <a-descriptionsItem label="账户名称">
          {{ setting.invoice_title
          }}<a-icon type="copy" class="cursor-pointer" @click="copy(setting.invoice_title)" />
        </a-descriptionsItem>
        <a-descriptionsItem label="开户行">
          {{ setting.invoice_bank }}
          <a-icon type="copy" class="cursor-pointer" @click="copy(setting.invoice_bank)"
        /></a-descriptionsItem>
        <a-descriptionsItem label="开户行账号">
          {{ setting.invoice_bank_account }}
          <a-icon type="copy" class="cursor-pointer" @click="copy(setting.invoice_bank_account)" />
        </a-descriptionsItem>
        <a-descriptionsItem label="开户行行号">
          {{ setting.bank_code
          }}<a-icon type="copy" class="cursor-pointer" @click="copy(setting.bank_code)" />
        </a-descriptionsItem>
        <a-descriptionsItem label="金额">
          <div class="text-red-500">
            {{ ct.poundage ? ct.poundage.toFixed(2) : '' }}({{
              convertCurrency(parseFloat(ct.poundage ? ct.poundage.toFixed(2) : ''))
            }})
            <a-icon
              type="copy"
              class="text-black cursor-pointer"
              @click="copy(ct.poundage ? ct.poundage.toFixed(2) : '')"
            />
          </div>
        </a-descriptionsItem>
        <a-descriptionsItem>
          <div class="flex"
            ><span class="block mt-2 text-2xl font-bold text-red-500">*</span>
            <span class="mt-2">汇款用途附言: </span
            ><span class="text-3xl font-bold text-red-500">{{ ct.code }}</span>
            <a-icon type="copy" class="mt-3 cursor-pointer" @click="copy(ct.code)"
          /></div>
         </a-descriptionsItem>
        <a-descriptions-item label="推荐码">{{
          ct.p_user_id > 0 ? ct.p_user_id : ''
        }}</a-descriptions-item>
        <a-descriptionsItem label="开户许可证" v-if="ct.temp.is_certificate">
          <div class="overflow-hidden">
            <CertificateUpload
              :src="ct.company.certificate_src"
              @upload="certUpload"
            ></CertificateUpload>
          </div>
        </a-descriptionsItem>
      </a-descriptions>
      <div class="text-red-500">
        <div class="text-base font-bold">温馨提示</div>
        <div>1．保函费汇款转账 <span class="text-2xl font-bold text-red-500">用途或附言</span>内容，除序列号以外，请勿备注其他内容。</div>
        <div> 2．如果不是从基本户付款或者登记的基本户账号有误，因此造成的后果由贵公司负责。 </div>
        <!-- <div>
          3．如果一个小时或者更长时间未出函，请
          <a-upload
            :before-upload="beforeUpload"
            :customRequest="api"
            accept="image/jpeg,image/png"
            :show-upload-list="false"
          >
            <a disabled v-if="loading">上传中</a>
            <a v-else>{{ isUpload ? '重新上传打款凭证' : '上传打款凭证' }}</a>
          </a-upload>
          ，并联系客服人员。
        </div> -->
        <div> 3．为防止企业客户信息被泄露，预防措施必不可少，故项目信息开标后解密 </div>
        <div>
          4．因银行转账存在延迟的问题，请尽量在项目开标或保证金缴纳截至时间前2小时完成支付。
        </div>
      </div>
    </div>
    <div class="h-8"></div>
  </div>
</template>
<script>
  import CertificateUpload from '@/components/CertificateUpload/index';
  import { config } from '@/api/config';
  import { convertCurrency } from '@/utils/transContent';
  import { companyCertificateModify } from '@/api/company';
  export default {
    components: {
      CertificateUpload,
    },
    props: {
      ct: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        setting: {},
        company: {},
      };
    },
    async mounted() {
      this.setting = (await config()) || {};
    },
    computed: {
    },
    watch: {
      ct(a) {
        console.log(a);
      },
    },
    methods: {
      convertCurrency,
      back() {
        this.$router.push(`/admin/contract_detail/${this.ct.id}`);
      },
      copy(str) {
        const input = document.getElementById('input');
        input.value = str;
        input.focus();
        if (input.setSelectionRange) {
          input.setSelectionRange(0, input.value.length);
          console.log(input.setSelectionRange(0, input.value.length));
        } else {
          input.select();
        }
        try {
          const result = document.execCommand('copy');
          if (result) {
            this.$message.success('复制成功');
          }
        } catch (e) {
          console.log(e);
          console.error('复制失败，请重试~');
        }
      },
      async certUpload(res) {
        this.company = this.ct.company;
        try {
          this.spinning = true;
          this.company.certificate_id = res.id;
          this.company.certificate_src = res.pathname;
          await companyCertificateModify(this.company);
        } catch (error) {
          this.$error({ title: '错误提示', content: error });
        } finally {
          this.spinning = false;
        }
      },
    },
  };
</script>
<style lang="less" scoped>
  .step3 {
    width: 750px;
    margin: 0 auto;
  }
  .desc-wrap {
    padding: 24px 40px;
    margin-top: 24px;
    background-color: #eeeeee;
  }
  .cursor-pointer {
    margin-left: 6px !important;
  }
  :deep(.ant-descriptions-item-label) {
    width: 200px !important;
    text-align: right;
    float: left;
  }
  :deep(.ant-descriptions-item-content) {
    float: right;
    width: 470px;
  }
</style>
